import React from 'react';
import { Card, Badge } from '@/components/ui';
import type { RecentTenant } from '../../types/dashboard.types';

interface RecentTenantsTableProps {
  tenants: RecentTenant[];
}

export function RecentTenantsTable({ tenants }: RecentTenantsTableProps) {
  return (
    <Card className="p-6 border-slate-100 shadow-sm col-span-1 lg:col-span-1 flex flex-col h-[320px]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-slate-900">Tổ chức mới nhất</h3>
        <button className="sm:text-sm text-xs font-medium text-emerald-600 hover:text-emerald-700">Xem tất cả</button>
      </div>
      
      <div className="flex-1 overflow-auto scrollbar-none">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-slate-100">
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs">Tổ chức</th>
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs">Gói dịch vụ</th>
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs text-center">Người dùng</th>
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs">Ngày tạo</th>
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs text-right">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {tenants.map((item, idx) => (
              <tr key={idx} className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                <td className="py-3 sm:text-sm text-xs font-medium text-slate-700">{item.name}</td>
                <td className="py-3 sm:text-sm text-xs font-medium text-slate-600">{item.plan}</td>
                <td className="py-3 sm:text-sm text-xs font-medium text-slate-900 text-center">{item.users}</td>
                <td className="py-3 sm:text-sm text-xs font-medium text-slate-500">{item.date}</td>
                <td className="py-3 text-right">
                  {item.status === 'active' ? (
                    <Badge variant="custom" className="bg-emerald-50 text-emerald-600 border-emerald-100 px-2 py-0.5 sm:text-sm text-xs">
                      Hoạt động
                    </Badge>
                  ) : item.status === 'locked' ? (
                    <Badge variant="custom" className="bg-red-50 text-red-600 border-red-100 px-2 py-0.5 sm:text-sm text-xs">
                      Khóa
                    </Badge>
                  ) : (
                    <Badge variant="custom" className="bg-slate-50 text-slate-500 border-slate-200 px-2 py-0.5 sm:text-sm text-xs">
                      Chưa kích hoạt
                    </Badge>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
